import { useAuthStore } from '@/stores/useAuthStore'

import { createWebSocketTableStore } from '../table'
import { transformLeaderboardDataToRows } from './leaderboard.store.helpers'

export const useLeaderboardStore = createWebSocketTableStore({
  storeName: 'DDE Golf Pricing - Leaderboard',
  features: {
    pagination: false,
    sorting: true,
    filtering: true
  },
  websocketConfig: {
    getUrl: (tournamentId) =>
      `${import.meta.env.VITE_DDE_MSFP_WEBSOCKET}/golf/tournaments/${tournamentId}/leaderboard`,
    transformData: transformLeaderboardDataToRows,
    getAuthToken: () => useAuthStore.getState().token,
    shouldReuseConnection: (currentTournamentId, newTournamentId) =>
      currentTournamentId === newTournamentId
  }
})
